import { Box, Table, Tbody, Td, Text, Th, Thead, Tr, VStack } from "@chakra-ui/react"
import { differenceInSeconds, format, isValid } from "date-fns"
import React, { Fragment } from "react"
import { getDurationInWords } from "../../../utils"

export type ComprehensiveUserAttendanceReportProps = {
	report: any
}

export const ComprehensiveUserAttendanceReport: React.FC<ComprehensiveUserAttendanceReportProps> = ({ report }) => {
	return (
		<Box w="full" overflow="auto">
			<Table overflow="hidden" colorScheme="blackAlpha" bg="white" rounded="xl">
				<Thead>
					<Tr>
						<Th textTransform="capitalize">Users</Th>
						{report.labels.map((label: any) => (
							<Th key={label} textTransform="capitalize" w="12">
								{isValid(new Date(label)) ? format(new Date(label), "dd/MMM/yyyy") : "Invalid Date"}
							</Th>
						))}
					</Tr>
				</Thead>
				<Tbody>
					{report.attendances.map((a: any, i: any) => {
						return (
							<Fragment key={i}>
								<Tr key={i} _hover={{ bg: "gray.100" }} transition="background-color 200ms ease-in" cursor="pointer" fontSize="sm">
									<Td key={i}>{a.user}</Td>
									{a?.labeledAttendances?.map((l: any, i: any) => (
										<Td key={i}>
											{l.isAbsent ? (
												<VStack gap={2} justifyContent="flex-start">
													<Text as="span" textAlign={"center"}>
														-
													</Text>
												</VStack>
											) : (
												<VStack gap={2} justifyContent="flex-start">
													<Text as="span" textAlign={"center"}>
														{" "}
														InAt : {isValid(new Date(l?.inAt)) ? format(new Date(l?.inAt), "HH:mm") : "Invalid Date"}
													</Text>
													{" | "}
													<Text as="span" textAlign={"center"}>
														{" "}
														OutAt : {isValid(new Date(l?.outAt)) ? format(new Date(l?.outAt), "HH:mm") : "Invalid Date"}
													</Text>{" "}
													{" | "}{" "}
													<Text as="span" textAlign={"center"}>
														{" "}
														Duration : {`${getDurationInWords(differenceInSeconds(new Date(l.outAt), new Date(l.inAt)))} `}
													</Text>
													{" | "}
													{l?.inRemarks && (
														<Text as="span" textAlign={"center"}>
															{" "}
															In Remarks : {`${l?.inRemarks}`}
														</Text>
													)}
													{l?.outRemarks && (
														<Text as="span" textAlign={"center"}>
															{" "}
															Out Remarks : {`${l?.outRemarks}`}
														</Text>
													)}
												</VStack>
											)}
										</Td>
									))}
								</Tr>
							</Fragment>
						)
					})}
				</Tbody>
			</Table>
		</Box>
	)
}
